import React from 'react';
import lodash from 'lodash';
import moment from 'moment';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import FieldSet from '../../../../fieldset/FieldSet';
import SearchBar from '../../../../searchbar/SearchBar';
import Grid from '../../../../grid/Grid';
import AsyncActionButton from '../../../../button/AsyncActionButton';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import UtilitiesService from '../../../../../service/UtilitiesService';
import KCKTaxDetailedBillModal from './KCKTaxDetailedBillModal';
import AccountLinkForm from '../../../../form/AccountLinkForm';

class KCKTax extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      accountHeaders: [],
      accountRows: [],
    };

    this.comboFields = [
      {
        value: 'externalAccountId',
        display: 'External Account ID',
      },
      {
        value: 'customerId',
        display: 'Customer ID',
      },
    ];
  }

  SERVICE_OFFERING_ID = 'kck_tax';

  onAccountRowSelect(selectedRow) {
    const { accountRows, selectedAccount, } = this.state;

    if (selectedAccount && selectedAccount.id !== selectedRow.id) {
      this.resetBills();
    }

    const account = accountRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedAccount: account.raw,
    });
  }

  onBillRowSelect(selectedRow) {
    const { billRows, } = this.state;
    const selectedBill = billRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedBill: selectedBill.raw,
    });
  }

  onClickSearch(event) {
    this.reset();
    const { combo, search, } = event;
    const rows = [];
    let headers = [];
    const criteria = {};
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = this.SERVICE_OFFERING_ID;

    const allowedKeys = [
      'id', // TODO hide id
      'externalAccountId',
      'propertyTypeCode',
      'parcelNumber',
    ];

    UtilitiesService.getUtilityAccountBySearch(criteria)
      .then((response) => {
        const { accounts, } = response.data;

        if (accounts.length > 0) {
          headers = allowedKeys.map(header => ({
            value: header,
            display: lodash.startCase(header),
          }));

          accounts.forEach((account) => {
            const filtered = lodash.pick(account, allowedKeys);

            rows.push({
              value: Object.values(filtered),
              raw: account,
            });
          });

          this.setState({
            accountHeaders: headers,
            accountRows: rows,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  onBillClick(accountId) {
    this.resetBills();
    this.setState({
      isBillLoading: true,
    });
    const rows = [];
    let headers = [];
    const criteria = {};
    criteria.accountId = accountId;
    criteria.serviceOfferingId = this.SERVICE_OFFERING_ID;

    const allowedKeys = [
      'id', // TODO hide id
      'taxYear',
      'dueDate',
      'isPaid',
      'propertyTypeCode',
      'externalAccountId',
      'parcelNumber',
    ];

    UtilitiesService.getUtilityBillBySearch(criteria)
      .then((response) => {
        const { bills, } = response.data;

        if (bills.length > 0) {
          headers = allowedKeys.map(header => ({
            value: header,
            display: lodash.startCase(header),
          }));

          bills.forEach((bill) => {
            const filtered = lodash.pick(bill, allowedKeys);
            filtered.dueDate = moment(filtered.dueDate).utc().format();

            rows.push({
              value: Object.values(filtered),
              raw: bill,
            });
          });

          this.setState({
            billHeaders: headers,
            billRows: rows,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState({ isBillLoading: false, });
      });
  }

  resetBills() {
    this.setState({
      billHeaders: [],
      billRows: [],
      selectedBill: null,
    });
  }

  showSelectedAccountDetails(selectedAccount) {
    const { isBillLoading, } = this.state;
    if (!selectedAccount) {
      return null;
    }
    return (
      <div className="container-fluid">
        <p>{`Selected ID: ${selectedAccount.id}`}</p>
        <hr />
        <div className="row">
          <span className="m-1">
            <AsyncActionButton
              onClick={() => this.onBillClick(selectedAccount.id)}
              contents="Show Bills"
              isLoading={isBillLoading}
              variant="primary"
              loadingVariant="secondary"
            />
          </span>
          <span className="m-1">
            <AccountLinkForm
              title="Link/Unlink Customers"
              id={selectedAccount.id}
              customerIds={ObjectUtils.formatStringAsJSONArray(selectedAccount.customerIds)}
              serviceOfferingId={this.SERVICE_OFFERING_ID}
            />
          </span>
        </div>
      </div>
    );
  }

  showSelectedBillDetails(selectedBill) {
    if (!selectedBill) {
      return null;
    }
    return (
      <div>
        <p>{`Selected ID: ${selectedBill.id}`}</p>
        <hr />
        <KCKTaxDetailedBillModal bill={selectedBill} />
      </div>
    );
  }

  reset() {
    this.setState({
      accountHeaders: [],
      accountRows: [],
      billHeaders: [],
      billRows: [],
      selectedAccount: null,
      selectedBill: null,
    });
  }

  render() {
    const {
      accountHeaders = [],
      accountRows = [],
      billHeaders = [],
      billRows = [],
      selectedAccount,
      selectedBill,
    } = this.state;

    return (
      <div className="container">
        <SearchBar
          comboFields={this.comboFields}
          onClick={data => this.onClickSearch(data)}
          style={{ maxHeight: '300px', }}
        />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="KCK Tax Accounts">
            <Grid
              headers={accountHeaders}
              rows={accountRows}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
              onRowSelect={row => this.onAccountRowSelect(row)}
              style={{ maxHeight: '300px', }}
            />
          </FieldSet>
          {this.showSelectedAccountDetails(selectedAccount)}
        </div>
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="KCK Tax Bills" style={{ maxHeight: '300px', }}>
            <Grid
              headers={billHeaders}
              rows={billRows}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
              onRowSelect={row => this.onBillRowSelect(row)}
            />
          </FieldSet>
          {this.showSelectedBillDetails(selectedBill)}
        </div>
      </div>
    );
  }
}

export default KCKTax;
